import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'

import styles from './NewCheckBoxButton.module.scss'
import { NewCheckBoxProps } from './NewCheckBoxButton.types'

export const NewCheckBoxButton = ({
  label,
  value,
  onChange,
  name,
  classes = [],
  checked = false,
  type = 'checkbox',
  nameEventReset,
}: NewCheckBoxProps) => {
  const [active, setActive] = useState<boolean>(false)

  const clickHandler = (e: ChangeEvent<HTMLInputElement>) => {
    if (type === 'checkbox') {
      setActive(!active)
    }
    onChange(e)
  }

  const reset = () => {
    setActive(checked)
  }

  useEffect(() => {
    setActive(checked)
  }, [checked])

  useEffect(() => {
    if (nameEventReset) {
      document.addEventListener(nameEventReset, reset)
    }

    return () => {
      if (nameEventReset) {
        document.removeEventListener(nameEventReset, reset)
      }
    }
  }, [])

  return (
    <label
      className={[
        styles.NewCheckbox,
        ...classes.map(el => styles[`NewCheckbox--${el}`] as string),
      ].join(' ')}
    >
      <input
        type={type}
        style={{ display: 'none' }}
        onChange={e => clickHandler(e)}
        value={value}
        name={name ? name : ''}
        checked={active}
      />
      <span>{label}</span>
    </label>
  )
}
